import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { BlogProvider } from './context/BlogContext';
import { HowToVideoProvider } from './context/HowToVideoContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Logistics from './pages/Logistics';
import Bookings from './pages/Bookings';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SupportPage from './pages/Support';
import TermsOfUse from './pages/TermsOfUse';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import HowToVideos from './pages/HowToVideos';
import HowToVideoPost from './pages/HowToVideoPost';

function App() {
  return (
    <ThemeProvider>
      <BlogProvider>
        <HowToVideoProvider>
        <Router>
          <ScrollToTop />
          <div className="min-h-screen bg-white">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/logistics" element={<Logistics />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/how-to-videos" element={<HowToVideos />} />
              <Route path="/how-to-videos/:slug" element={<HowToVideoPost />} />
            </Routes>
            <Footer />
          </div>
        </Router>
        </HowToVideoProvider>
      </BlogProvider>
    </ThemeProvider>
  );
}

export default App;
